import { Pipe, PipeTransform } from '@angular/core';
import { PliDisplayFormat } from '../models/pli-format';
import Enums from '@xbs/xbs-enums';
/**
 * Use this pipe to keep desired number values to XBS's standard PLI format.
 */

@Pipe({ name: 'xbsPliFormat' })
export class XbsPliFormatPipe implements PipeTransform {

  constructor() { }

  transform(value: any, pliType: string, pliDisplayFormat: PliDisplayFormat[] = []): string {
    if (!value) {
      return '';
    }

    let formatted;

    const pliTypeFormat = pliDisplayFormat.find(pli => pli.pliTypeId === Enums.PliDisplayFormats.ByName[pliType].Id);
    const isDecimal = pliTypeFormat && pliTypeFormat.hasOwnProperty('displayFormat') ? pliTypeFormat.displayFormat : Enums.PliDisplayFormats.ByName[pliType] && Enums.PliDisplayFormats.ByName[pliType].Value.displayFormat;

    let roundingValue = pliTypeFormat && pliTypeFormat.hasOwnProperty('roundingValue') ? pliTypeFormat.roundingValue : Enums.PliDisplayFormats.ByName[pliType] && Enums.PliDisplayFormats.ByName[pliType].Value.roundingValue;

    if (isDecimal && Number(isDecimal)) {
      formatted = this.roundValue(Number(value), -roundingValue).toFixed(roundingValue);
    }

    formatted = formatted || `${this.roundValue((Number(value + 'e2')), -roundingValue).toFixed(roundingValue)}%`;

    return formatted === 'NaN' ? value : formatted;
  }

  roundValue(value: number, exp: number) {
    if (typeof exp === 'undefined' || Number(exp) === 0) {
      return Math.round(value);
    }
    value = Number(value);
    exp = Number(exp);
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    const convertedIntegerValue = Math.round(Number(value + 'e' + (-exp)));
    const backToFloatValue = Number(convertedIntegerValue + 'e' + exp);

    return backToFloatValue;
  }

}
